import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
// export const constantRouterMap = [
//   {path: '/login', component: () => import('@/views/login/index'), hidden: true},
//   {path: '/404', component: () => import('@/views/404'), hidden: true},
//   {
//     path: '',
//     component: Layout,
//     redirect: '/home',
//     children: [{
//       path: 'home',
//       name: 'home',
//       component: () => import('@/views/home/index'),
//       meta: {title: '首页', icon: 'home'}
//     }]
//   }
// ]

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/directLogin',
    component: () => import('@/views/directLogin/index'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { navId: 1 },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
  //商品管理
  {
    path: '/commodityManagement',
    component: Layout,
    name: 'commodityManagement',
    meta: { navId: 5},
    children: [
      {
        path: 'index',
        name: 'commodityManagement',
        component: () => import('@/views/commodityManagement/index'),
        meta: { title: '商品管理', icon: 'cm' }
      },
      {
        path: 'edit',
        name: 'commodityEdit',
        component: () => import('@/views/commodityManagement/edit'),
        meta: { title: '商品详情' },
        hidden: true
      },
    ]
  },
  //商品日志管理
  {
    path: '/commodityManagement/history',
    component: Layout,
    name: 'commodityManagementHistory',
    meta: { navId: 6},
    children: [
      {
        path: 'index',
        name: 'productHistory',
        component: () => import('@/views/commodityManagement/history/index'),
        meta: { title: '商品调整记录', icon: 'cm' }
      }
    ]
  },

  //订单Order
  {
    path: '/order/commodity',
    component: Layout,
    name: 'order',
    meta: { navId: 9},
    children: [

      {
        path: 'index',
        name: 'commodityOrder',
        component: () => import('@/views/order/commodity/index'),
        meta: { title: '订单管理', icon: 'ddxq' }
      },
      {
        path: 'edit',
        name: 'commodityOrderEdit',
        component: () => import('@/views/order/commodity/edit'),
        meta: { title: '商品订单详情' },
        hidden: true
      },
    ]
  },
  //用户金币余额查询
  {
    path: '/memberGold',
    name: 'memberGold',
    component: Layout,
    meta: { navId: 12 },
    children: [{
      path: "index",
      name: 'memberGold',
      component: () => import('@/views/memberGold/index'),
      meta: { title: '用户金币余额查询', icon: 'sb' }
    }]
  },
  //金币收支明细
  {
    path: '/pointDetails',
    component: Layout,
    name: 'pointDetails',
    meta: { navId: 4},
    children: [
      {
        path: 'index',
        name: 'pointDetails',
        component: () => import('@/views/pointDetails/index'),
        meta: { title: '金币收支明细', icon: 'pd' }
      },
      {
        path: 'edit',
        name: 'pointEdit',
        component: () => import('@/views/pointDetails/edit'),
        meta: { title: '金币收支明细详情' },
        hidden: true
      },
    ]
  },

  //金币消耗对账
  {
    path: '/spendBill',
    name: 'spendBill',
    component: Layout,
    meta: { navId: 10 },
    children: [{
      path: "index",
      name: 'spendBill',
      component: () => import('@/views/spendBill/index'),
      meta: { title: '金币消耗对账', icon: 'sb' }
    }]
  },
  //系统设置
  {
    path: '/setting',
    name: 'config',
    component: Layout,
    meta: { navId: 11 },
    children: [{
      path: "index",
      name: 'config',
      component: () => import('@/views/setting/index'),
      meta: { title: '系统设置', icon: 'sb' }
    }]
  },



  // {
  //   path: '/refund',
  //   name: 'refund',
  //   component: Layout,
  //   meta: { navId: 11 },
  //   children: [{
  //     path: "index",
  //     name: 'refund',
  //     component: () => import('@/views/refund/index'),
  //     meta: { title: '账号配置', icon: 'Refund' }
  //   }]
  // },


  //
  // {
  //   path: '/checkAccount',
  //   name: 'checkAccount',
  //   component: Layout,
  //   meta: { navId: 12 },
  //   children: [{
  //     path: "index",
  //     name: 'checkAccount',
  //     component: () => import('@/views/checkAccount/index'),
  //     meta: { title: '到账情况查询', icon: 'sms-coupon' }
  //   }]
  // },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js